export default __webpack_public_path__ + "static/media/school-bus-transport.2b2cf3cb.png";